import { render } from "./app-button-business.vue?vue&type=template&id=5e248bab&scoped=true"
import script from "./app-button-business.vue?vue&type=script&lang=js"
export * from "./app-button-business.vue?vue&type=script&lang=js"

import "./app-button-business.vue?vue&type=style&index=0&id=5e248bab&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e248bab"]])

export default __exports__